import { Pipe } from '@angular/core';
import { LicenciasPorEquipo_Licencia } from "../models/licencias";

@Pipe({
    name: 'AuxiliaresPipe'
})
export class AuxiliaresPipe {

  transform(value, args?) {
    let codigos: Array<string> = ['D', 'DC', 'DS', 'DB', 'DBS', 'DJ', 'DJS', 'DR', 'DRS'];

    return value.filter((item: LicenciasPorEquipo_Licencia) => {
      let resultado: boolean = false;
      codigos.forEach((valor: string, i: number) => {
        if (valor == item.codigoLicencia) {
          resultado = true;
        }
      });
      return resultado;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/auxiliares.ts